import Immutable from "immutable";

export default Immutable.Record({
  title: "",
  category: "",
  test_time: 0,
  shuffle_exercises: false,
});
